import { Component} from '@angular/core'; 
import { HttpClient} from '@angular/common/http'; 
import { environment } from '.../../environments/environment'; 
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';  
import { AuthService } from '../../_services'; 
import { LoaderService } from '../../_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'tonnage-DashBoard',
  templateUrl: './tonnageDashboard.component.html', 
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ], 
}) 



    export class TonnageDashBoardComponent {  
    mswSummaryList:any;
    prjId:any;
    ecoTodayTonnage:any;
    ecoYesterdayTonnage:any;
    ecoMtdTonnage:any;
    contTodayTonnage:any;
    contYesterdayTonnage:any;
    contMtdTonnage:any;
    ecoTodayFuelQty:any;
    ecoYesterdayFuelQty:any;
    ecoMtdFuelQty:any;
    contTodayFuelQty:any;
    contYesterdayFuelQty:any;
    contMtdFuelQty:any;
    fuelSummaryList:any; 
    ecoTodayVehCount:any;
    ecoYestdVehCount:any;
    ecoMtdVehCount:any;
    contTodayVehCount:any;
    contYestdVehCount:any;
    contMtdVehCount:any;
    todaysContractorList:any;
    MTDContractorList:any;
    startDate:any;
    endDate:any;
    tonnageGraphList:any;
    defStartDt:any;
    defEndDt:any;
    dateRange:any;
    showLoader:any;
    zoneWiseTonnageList:any;
    fuelQtyList:any;
      constructor(private http : HttpClient ,private auth : AuthService,private loaderService: LoaderService) {
        this.loaderService.status.subscribe((val: boolean) =>{
          this.showLoader = val;
        }); 
      this.ecoYestdVehCount=0;
      this.ecoMtdVehCount=0;
      var date=new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1); 
      this.defStartDt = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();  
      this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate();  
      this.dateRange= {
                       beginDate: {year: firstDay.getFullYear(), month: firstDay.getMonth()+1, day: firstDay.getDate()}, 
                       endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}
                      };
      }


      /*
      *get MSW REPORT 
      */ 
      getMswSummary(){
        this.http.get(environment.apiUrl+'reports/getMswTognnageSummary?prjId='+this.prjId).subscribe(data =>{       
          this.mswSummaryList=data;  
          this.ecoTodayTonnage=this.mswSummaryList[0].Today_Ecogreen
          this.ecoYesterdayTonnage=this.mswSummaryList[0].yesterday_Ecogreen
          this.ecoMtdTonnage=this.mswSummaryList[0].MTD_Ecogreen
          this.contTodayTonnage=this.mswSummaryList[0].Today_Others
          this.contYesterdayTonnage=this.mswSummaryList[0].yesterday_Others
          this.contMtdTonnage=this.mswSummaryList[0].MTD_Others
          //Trip
          this.ecoTodayVehCount=this.mswSummaryList[0].TodayCount_Ecogreen
          this.ecoYestdVehCount=this.mswSummaryList[0].yesterdayCount_Ecogreen
          this.ecoMtdVehCount=this.mswSummaryList[0].MTDCount_Ecogreen
          this.contTodayVehCount=this.mswSummaryList[0].TodayCount_Others
          this.contYestdVehCount=this.mswSummaryList[0].yesterdayCount_Others
          this.contMtdVehCount=this.mswSummaryList[0].MTDCount_Others
        });
      }


      /*
      *ECO GREEN AND CONTRACTORT COUNT
     */  
    //  getTonnageSummary(){
    //     this.http.get(environment.apiUrl+'reports/getTonnageSummary?prjId='+this.prjId).subscribe(data =>{       
    //     this.tonnageReportList=data;  
    //     this.ecoTodayVehCount=this.tonnageReportList[0].EcoTodaysVehCount
    //     this.ecoYestdVehCount=this.tonnageReportList[0].EcoYesterdayVehCount
    //     this.ecoMtdVehCount=this.tonnageReportList[0].EcoMTDVehCount
    //     this.contTodayVehCount=this.tonnageReportList[0].ContTodaysVehCount
    //     this.contYestdVehCount=this.tonnageReportList[0].ContYesterdayVehCount
    //     this.contMtdVehCount=this.tonnageReportList[0].ContMTDVehCount
    //   });
    // }

      /*
      *GET ECO GREEN and CONTRACTORT FUEL QUENTITY
      */ 
     getFuelSummary(){
      this.http.get(environment.apiUrl+'reports/getFuelPurchaseSummary?prjId='+this.prjId).subscribe(data =>{       
        this.fuelSummaryList=data;  
        this.ecoTodayFuelQty=this.fuelSummaryList[0].EcoTodayFuelQty
        this.ecoYesterdayFuelQty=this.fuelSummaryList[0].EcoYesterdayFuelQty
        this.ecoMtdFuelQty=this.fuelSummaryList[0].EcoMTDFuelQty
        this.contTodayFuelQty=this.fuelSummaryList[0].ContTodayFuelQty
        this.contYesterdayFuelQty=this.fuelSummaryList[0].ContYesterdayFuelQty
        this.contMtdFuelQty=this.fuelSummaryList[0].ContMTDFuelQty
      });
    }


    


     /*
      *TODAYS CONTRACTOR TONNAGE SUMMARY
      */  
     getTodaysContractorSummary(){
      this.http.get(environment.apiUrl+'reports/getTodaysContractorSummary?prjId='+this.prjId).subscribe(data =>{       
        this.todaysContractorList=data;  
      });
    }

      /*
      *MTD CONTRACTOR TONNAGE SUMMARY
      */  
     getMTDContractorSummary(){
      this.http.get(environment.apiUrl+'reports/getMTDContractorSummary?prjId='+this.prjId).subscribe(data =>{       
        this.MTDContractorList=data;  
      });
    }

      /*
      *TONNAGE GRAPH REPORT
      */  
     getTonnageGraphSummary(startDt,endDt){
        this.http.get(environment.apiUrl+'reports/getTonnageGrapReport?prjId='+this.prjId+'&startDate='+startDt+'&endDate='+endDt).subscribe(data =>{       
        this.tonnageGraphList=data;
        console.log("Graph Dataa",this.tonnageGraphList)  
      });
    }

          
    /*
    *select start Date Nad To date
    */
    onDateRangeChanged(dataRange){  
      if(dataRange.beginDate.day>0){ 
        this.startDate= dataRange.beginDate.year + "-"  + dataRange.beginDate.month+ "-" + dataRange.beginDate.day 
        this.endDate = dataRange.endDate.year + "-"  + dataRange.endDate.month  + "-" + dataRange.endDate.day 
        this.getTonnageGraphSummary(this.startDate,this.endDate)
        this.getFuelQtyDateWise(this.startDate,this.endDate)
      }else if(dataRange.beginDate.day==0){ 
        this.getTonnageGraphSummary(this.defStartDt,this.defEndDt)
        this.getFuelQtyDateWise(this.defStartDt,this.defEndDt)
      }  
    }  

     /*
      *GET ZONE WISE TONNAGE REPORT
      */  
     getZoneWiseTonnageSummary(){
      this.http.get(environment.apiUrl+'reports/getZoneWiseTonnage?prjId='+this.prjId).subscribe(data =>{       
      this.zoneWiseTonnageList=data;
      console.log("zoneWiseTonnageList",this.zoneWiseTonnageList)  
    });
   }
    


     /*
      *GET FUEL QTY DATE WISE ONLY FOR ECOGREEN VEHICLE
      */  
     getFuelQtyDateWise(fromDate,toDate){
      this.http.get(environment.apiUrl+'reports/getFuelQtyDateWise?prjId='+this.prjId+'&startDate='+fromDate+'&endDate='+toDate).subscribe(data =>{       
      this.fuelQtyList=data;
      console.log("fuelQtyList",this.fuelQtyList)  
    });
   }
    



        ngOnInit(): void{ 
          this.prjId = this.auth.getAuthentication().projectId 
          this.getMswSummary();
          this.getFuelSummary();
          //This.getTonnageSummary();
          this.getTodaysContractorSummary();
          this.getMTDContractorSummary();
          this.startDate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY-MM-DD');
          this.endDate= moment(new Date()).format('YYYY-MM-DD');
          this.getTonnageGraphSummary(this.startDate,this.endDate)
          this.getZoneWiseTonnageSummary();
          this.getFuelQtyDateWise(this.startDate,this.endDate)
        }
      }











// WEBPACK FOOTER //
// ./src/app/dashboard/tonnage/tonnageDashboard.component.ts